"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filtersByAllFiltersAndCriterion = exports.isPassageFilter = exports.isDeviceFilter = exports.isZoneFilter = exports.isCountryFilter = exports.isCityFilter = exports.isDayFilter = exports.isDateFilter = exports.isTimeFilter = exports.isTagCategoryFilter = exports.isTagFilter = exports.isAgeCategoryFilter = exports.isGenderFilter = exports.isFilter = exports.findPhysicalInformationFilters = exports.isCondition = exports.PHYSICAL_INFORMATION_FILTERS = exports.DEFAULT_RETAIL_DATE_FORMAT_WITHOUT_TIMEZONE = exports.DEFAULT_RETAIL_DATE_FORMAT = void 0;
var types_1 = require("../types");
exports.DEFAULT_RETAIL_DATE_FORMAT = "DD-MM-YYYY";
exports.DEFAULT_RETAIL_DATE_FORMAT_WITHOUT_TIMEZONE = "YYYY-MM-DDTHH:mm:ss";
exports.PHYSICAL_INFORMATION_FILTERS = [
    types_1.ConditionCriterions.CITY,
    types_1.ConditionCriterions.COUNTRY,
    types_1.ConditionCriterions.ZONES,
    types_1.ConditionCriterions.PASSAGES,
    types_1.ConditionCriterions.DEVICES,
    types_1.ConditionCriterions.TAGS,
    types_1.ConditionCriterions.TAG_CATEGORIES,
];
function isCondition(condition) {
    return condition.criterion !== undefined;
}
exports.isCondition = isCondition;
var findPhysicalInformationFilters = function (conditions) {
    return conditions.filter(function (condition) { return isCondition(condition) && exports.PHYSICAL_INFORMATION_FILTERS.includes(condition.criterion); });
};
exports.findPhysicalInformationFilters = findPhysicalInformationFilters;
var isFilter = function (criterion) { return function (filter) {
    return isCondition(filter) && filter.criterion === criterion;
}; };
exports.isFilter = isFilter;
exports.isGenderFilter = (0, exports.isFilter)(types_1.ConditionCriterions.GENDERS);
exports.isAgeCategoryFilter = (0, exports.isFilter)(types_1.ConditionCriterions.AGE_CATEGORY);
exports.isTagFilter = (0, exports.isFilter)(types_1.ConditionCriterions.TAGS);
exports.isTagCategoryFilter = (0, exports.isFilter)(types_1.ConditionCriterions.TAG_CATEGORIES);
exports.isTimeFilter = (0, exports.isFilter)(types_1.ConditionCriterions.TIME);
exports.isDateFilter = (0, exports.isFilter)(types_1.ConditionCriterions.DATE);
exports.isDayFilter = (0, exports.isFilter)(types_1.ConditionCriterions.DAY);
exports.isCityFilter = (0, exports.isFilter)(types_1.ConditionCriterions.CITY);
exports.isCountryFilter = (0, exports.isFilter)(types_1.ConditionCriterions.COUNTRY);
exports.isZoneFilter = (0, exports.isFilter)(types_1.ConditionCriterions.ZONES);
exports.isDeviceFilter = (0, exports.isFilter)(types_1.ConditionCriterions.DEVICES);
exports.isPassageFilter = (0, exports.isFilter)(types_1.ConditionCriterions.PASSAGES);
var filtersByAllFiltersAndCriterion = function (_a, criterion) {
    var conditions = _a.conditions;
    return conditions
        .flatMap(function (condition) {
        if (isCondition(condition)) {
            if (condition.criterion === criterion) {
                return condition;
            }
            return undefined;
        }
        else {
            return (0, exports.filtersByAllFiltersAndCriterion)(condition, criterion);
        }
    })
        .filter(Boolean);
};
exports.filtersByAllFiltersAndCriterion = filtersByAllFiltersAndCriterion;
